module.exports = __webpack_public_path__ + "img/Hubert Kraj.f5bfedd2.webp";